import React from 'react'
import { Field, reduxForm } from 'redux-form';
import Plus from "../../assets/images/pl.svg";
import close from "../../assets/images/close.svg";
import { Row, Col, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import validate from "./validate";
import "antd/dist/antd.css";


const renderSelectField = ({ input, meta: { touched, error }, children }) => (
    <div>
        <div>
            <select {...input} className='form-control form-select mt-4'>
                {children}
            </select>
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
)

const renderField = ({ input, placeholder, maxLength, type, select, meta: { touched, error } }) => (
    <div>
        <label></label>
        <div>
            <input  {...input} placeholder={placeholder} type={type} className="form-control" maxLength={maxLength} />
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
)

const VendorForm = props => {
    const { error, handleSubmit, show, onHide, page, reset, handleShow, empty, vendorbutton } = props;
    const showModal = () => {
        reset();
        handleShow();
    }


    return (
        <>
            {vendorbutton ? <button className="new-vendor" onClick={showModal}>
                <img src={Plus} alt="" /> Add Vendors
            </button> : <button className="add-staff" onClick={showModal}>
                <img src={Plus} alt="" /> Add Vendors
            </button>}
            <Modal
                show={show}
                size="lg"
                onHide={() => {
                    reset();
                    onHide();
                }}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}>
                <div className="modal-staff">
                    <div className="head">
                        <div>
                            <i class="fas fa-arrow-left" onClick={() => {
                                reset();
                                onHide();
                            }}></i>
                            <h4>{empty === "edit" ? "UPDATE" : "ADD NEW"} VENDOR</h4>
                        </div>
                        {empty === "edit" ?
                            <div style={{ marginLeft: 'auto' }}>
                                <Field name="active" component="select" className="form-control select-control" >
                                    <option value="" disabled={true}>Select One</option>
                                    <option value={true}>Active</option>
                                    <option value={false}>Inactive</option>
                                </Field>
                                <div className="triangle-status"></div>
                            </div>
                            : null}
                        {empty !== "edit" ? <span style={{ marginLeft: 'auto' }} onClick={() => {
                            reset();
                            onHide();
                        }}>
                            <img src={close} alt="..." width="18px" style={{ cursor: "pointer" }} />
                        </span> : <span onClick={() => {
                            reset();
                            onHide();
                        }}>
                            <img src={close} alt="..." width="18px" style={{ cursor: "pointer" }} />
                        </span>}
                    </div>
                    {/* <h4 className="customer-head">Vendor Details</h4> */}
                    <Row>
                        <form onSubmit={handleSubmit} className="customer">
                            <Row>
                                <Col md={4}>
                                    <div className='initial'>
                                        <label class="form-control-placeholder" for="name">Select one initial <span>*</span></label>
                                        <Field name="vendorInitial" component={renderSelectField} className="form-control form-select">
                                            <option value="Select one initial" hidden={true}></option>
                                            <option value="Mr" >Mr</option>
                                            <option value="M/s" >M/s</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss" >Miss</option>
                                        </Field>
                                        <div className="triangle-bottom"></div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <label class="form-control-placeholder" for="name">Name  <span>*</span></label>
                                    <Field name="firstName" type="text" component={renderField} maxLength="25" />
                                </Col>
                                {/* <Col md={4}>
                                    <label class="form-control-placeholder" for="name">Last Name</label>
                                    <Field name="lastName" type="text" component={renderField} maxLength="25" />
                                </Col> */}
                                <Col md={4} className="call-field">
                                    <label class="form-control-placeholder" for="name">Mobile No</label>
                                    <span className="call-now" > + 91 </span>
                                    <Field name="contactNumber" type="tel" component={renderField} maxLength="10" />
                                </Col>
                                <Col md={4}>
                                    <label class="form-control-placeholder" for="name">Primary Email Address <span>*</span></label>
                                    <Field name="email" type="email" component={renderField} />
                                </Col>
                                <Col md={4}>
                                    <label class="form-control-placeholder" for="name">Gst Number  <span>*</span></label>
                                    <Field name="gstNumber" type="text" component={renderField} maxLength="60" />
                                </Col>
                                <Col md={12}>
                                    <label class="form-control-placeholder" for="name">Address Line 1</label>
                                    <Field name="addressLine1" type="text" component={renderField} />
                                </Col>
                                <Col md={12}>
                                    <label class="form-control-placeholder" for="name">Address Line 2</label>
                                    <Field name="addressLine2" type="text" component={renderField} />
                                </Col>
                                <Col md={4}>
                                    <label class="form-control-placeholder" for="name">City  <span>*</span></label>
                                    <Field name="city" type="text" component={renderField} maxLength="25" />
                                </Col>
                                <Col md={4}>
                                    <label class="form-control-placeholder" for="name">State  <span>*</span></label>
                                    <Field name="state" type="text" component={renderField} maxLength="25" />
                                </Col>
                                <Col md={4}>
                                    <label class="form-control-placeholder" for="name">Pincode  <span>*</span></label>
                                    <Field name="pinCode" type="text" component={renderField} maxLength="6" />
                                    <Field name="vendorId" type="hidden" component={renderField} placeholder="Enter Email Address" />
                                </Col>
                                {error && <strong>{error}</strong>}
                                <Col md={6}>
                                    <button type="submit" className="customer-btn">
                                        {empty === "edit" ? "Update" : "Create"} Vendor
                                    </button>
                                </Col>
                            </Row>
                        </form>
                    </Row>
                </div>
            </Modal>
        </>
    )
}

function mapStateToProps(state) {
    let page = state.vendor.page;

    let initValues = page === "edit" ? state.vendor.vendor : {};

    return {
        initialValues: initValues,
        vendor: state.vendor.vendor,
        status: state.vendor.status,
        page: state.vendor.page
    }
}

const Form = reduxForm({
    form: "VendorForm",
    enableReinitialize: true,
    validate
})(VendorForm);

export default connect(mapStateToProps)(Form);


